import { render } from "./index.vue?vue&type=template&id=a95a2412"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/zhanghao/Documents/beijing/maidong/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__